exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-custom-scrollbar {\r\n    position: relative;\r\n    height: 400px;\r\n    overflow: auto;\r\n    }\r\n    .table-wrapper-scroll-y {\r\n    display: block;\r\n    }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/portals/portals.component.css
// module id = ../../../../../src/app/private/portals/portals.component.css
// module chunks = main